import { Component, Input, OnInit } from '@angular/core';
import { IboxtoolsItemUnico } from 'app/models/iboxtools-item-unico';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfigDataService } from '../../../../services/config-data.service';
import { OtroEmpleador } from '../../../../models/otroEmpleador';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { OtroEmpleadorService } from '../../../../services/otro-empleador.service';
import { OtroEmpleadorConcepto } from '../../../../models/otroEmpleadorConcepto';
import { OtroEmpleadorEditarDialogComponent } from '../otro-empleador-editar-dialog/otro-empleador-editar-dialog.component';
import { DatosOrganizativosService } from '../../../../services/datosOrganizativos.service';
import { MyValidations } from '../../../../utils/my-validations';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { PersonalService } from '../../../../services/personal.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-otro-empleador',
  templateUrl: './otro-empleador.component.html',
  styleUrls: ['./otro-empleador.component.css']
})

export class OtroEmpleadorComponent implements OnInit {
  mensajeExitoGuardado: string;

  constructor(private configDataSrv: ConfigDataService,
              private otroEmpleadorService: OtroEmpleadorService, 
              private fb: FormBuilder, 
              private dialog: MatDialog, 
              private snackBar: MatSnackBar, 
              private datosOrganizativosSrv: DatosOrganizativosService,
              private erroresService: ErroresService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private personalService: PersonalService,
              private momentService: MomentSetService ) { }

  @Input() legajo;
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;

  otroEmpleador: OtroEmpleador;
  conceptosList: any;
  form: FormGroup;
  otroEmpleadorList: any[];
  monedasList: any;
  clasesDocList: any;
  cortarRegistro: boolean = false;

  datosO: any;

  MensajeError: string;
  disabledEditing: boolean = true;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  submitted = false;

  otroEmpleadorHistoryList: any;
  toolboxEnabled: boolean = false;
  onlyNew: boolean = false;

  totalConceptos: number;
  totalImporte: number;
  monedaConcepto: string;
  
  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  otroEmpleadorInvalida: boolean = false;
  public cargaCompleta = false;
  MensajeRetro = "";

  get registerFormControl() { return this.form?.controls; }

  ngOnInit(): void
  {
    this.configDataSrv.getDatosDeducciones()
      .subscribe(
        data => {
          this.monedasList=data["Monedas"];
          this.clasesDocList=data["ClaseDocumentos"];
        },
        error => {
          console.log(error);
        });

    this.datosOrganizativosSrv.getByPersonalId(this.personalId).subscribe(
      data => 
      { 
        data.data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        this.datosO = data.data;
      });
    
    this.configurarValidadores();
    this.obtenerActual();
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Otro Empleador")) this.permisoEdicion = true;
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      fecha: ['', Validators.required],
      personal: ['', Validators.required],
      empleador: ['', Validators.required],
      claseDocumento: ['', Validators.required],
      docNro: ['', Validators.required]
    });
  }

  cargarConceptos(idOtroEmpleador)
  {    
    this.otroEmpleadorService.mostrarConceptos(idOtroEmpleador).subscribe(
    data =>
    {
        this.conceptosList = data;
        this.calcularTotalConceptos(data);
    });      
  }

  onChangeFechas() {
    this.chequeoRetro();   
  }
  
  setearForm(empleador: OtroEmpleador)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(empleador?.id);
      this.form.controls['personal'].setValue(empleador?.personal);
      this.form.controls['fecha'].setValue(new Date(empleador?.fecha));
      this.form.controls['empleador'].setValue(empleador?.empleador);
      this.form.controls['claseDocumento'].setValue(empleador?.claseDocumento);
      this.form.controls['docNro'].setValue(empleador?.docNro);

      if (empleador != null && empleador.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }

      this.chequeoRetro();
      this.cargarConceptos(empleador.id);
    }
  }

  calcularTotalConceptos(conceptos: OtroEmpleadorConcepto[])
  {
    let total = 0;
    let totalImporte = 0;
    for (let concepto of conceptos)
    {
      total += 1;
      totalImporte += concepto.importe;
    }

    this.totalConceptos = total;
    this.totalImporte = totalImporte;

    if (conceptos.length > 0)
    {
      this.monedaConcepto = conceptos[0].monedaNavigation.descripcion;
    }
    else
    {
      this.monedaConcepto = '';
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.otroEmpleador))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.otroEmpleadorService.delete(this.otroEmpleador.id).subscribe(
            response =>
            {
              this.snackBar.open("Otro Empleador eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              this.obtenerActual();
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.otroEmpleador))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['fecha'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let otroEmpleador = this.otroEmpleadorList.find(d => d.id == index);
    this.otroEmpleador = otroEmpleador;
    this.setearForm(this.otroEmpleador);
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    if (this.otroEmpleadorList != undefined)
    {
      if (this.otroEmpleador.id == 0 && this.otroEmpleadorList.length == 0)
      {
        this.otroEmpleador = null;
        this.conceptosList = null;
      }
      else if (this.otroEmpleador.id == 0 && this.otroEmpleadorList.length > 0)
      {
        this.otroEmpleador = this.otroEmpleadorList[0];
      }
    }
    else
    {
      this.otroEmpleador = null;
      this.conceptosList = null;
    }
    
    this.setearForm(this.otroEmpleador);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    this.submitted = true;
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.form.getRawValue();

      let datosOtro: OtroEmpleador = {
        id: formulario.id,
        personal: formulario.personal,
        fecha: this.momentService.saveDateServer(formulario.fecha, false),
        empleador: formulario.empleador,
        claseDocumento: formulario.claseDocumento,
        docNro: formulario.docNro,
        otroEmpleadorConcepto: []
      };

      this.otroEmpleadorService.save(datosOtro, [], this.cortarRegistro).subscribe(
        result =>
        {
          result.fecha = this.momentService.convertDateServer(result.fecha);
          
          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Otro Empleador guardado", "OK", { duration: 10000 });
          this.onlyNew = false;
          this.deshabilitarEdicion();

          this.obtenerHistorial();
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //result.fecha = result.fecha.replace('Z', '');
          this.setearForm(result);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.otroEmpleadorInvalida = true;
            
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      let fecha = new Date().toString();
      let otroE: OtroEmpleador = { id: 0, personal: this.personalId, fecha: fecha, otroEmpleadorConcepto: [] };
      this.otroEmpleador = otroE;
      this.setearForm(otroE);

      this.habilitarEdicion();
      this.form.controls['id'].setValue(0);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
    }
  }

  add()
  {    
    this.onlyNew = true;
    this.OnNewChange(true);
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarForm(false);
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarForm(true);
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.otroEmpleadorHistoryList = [];
    this.otroEmpleadorList = [];
    this.habilitarForm(false);
  }

  private obtenerHistorial()
  {
    this.otroEmpleadorService.getHistoryByPersonalId(this.personalId).subscribe(
      result =>
      {
        result.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.otroEmpleadorHistoryList = [];

        if (result.length > 0)
        {
          result.forEach(d =>
          {
            let item = new IboxtoolsItemUnico(d);
            this.otroEmpleadorHistoryList.push(item);
          });

          this.otroEmpleadorList = result;
        }
        else
        {
          this.setearForm(null);
          this.otroEmpleador = null;
          this.conceptosList = null;
          this.otroEmpleadorList = [];
        }
      },
      error =>
      {
        console.log(error);
      });
  }

  private obtenerActual()
  {
    let fechaHoy = new Date();
    this.otroEmpleadorService.getByPersonalId(this.personalId).subscribe(
      datos =>
      {
        datos.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        if (datos.length > 0)
        {
          this.otroEmpleador = datos.find(f=> Date.parse(f.fecha) <= fechaHoy.getTime() &&
                                              Date.parse(f.fecha) >= fechaHoy.getTime());

          if (this.otroEmpleador == null) this.otroEmpleador = datos[datos.length - 1];
          this.obtenerHistorial();
        }
        else
        {
          this.otroEmpleador = null;
          this.conceptosList = null;
        }
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    if (this.form.get("claseDocumento").value == 0)
    {
      this.form.get("claseDocumento").setErrors({ 'invalid': true });
    }    
    
    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let fecha = this.form.get("fecha").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(fecha) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.form.get("fecha").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(fecha) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.form.get("fecha").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.form.valid)
    {
      return true;
    }
    else
    {
      this.form.markAllAsTouched();
      return false;
    }
  }

  addConcepto(e)
  {
    let mone = 1;
    if (this.datosO[0].sociedadNavigation.moneda != undefined){
      mone = this.datosO[0].sociedadNavigation.moneda 
    }
    let concepto: OtroEmpleadorConcepto = {
      id: 0,
      idOtroEmpleador: this.otroEmpleador.id,
      moneda: mone
    };

    this.abrirDialogo(concepto, 0);
  }

  abrirDialogo(concepto: OtroEmpleadorConcepto, index: number)
  {
    let monedas = this.monedasList.filter(f => f.id == concepto.moneda);
    let fecha = this.form.get("fecha").value;

    let dialogRef = this.dialog.open(OtroEmpleadorEditarDialogComponent, {
      width: '700px',
      panelClass: 'overflow',
      data: { param: concepto,
              monedasList: monedas,
              fecha: fecha},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result != '')
      {
        if (concepto.id == 0)
        {
          this.conceptosList.unshift(result);
          this.mensajeExitoGuardado = "Datos guardados";
        }
        else
        {
          this.conceptosList[index] = result;
          this.mensajeExitoGuardado = "Datos actualizados";
        }

        this.conceptosList = [...this.conceptosList];

        this.cargarConceptos(concepto.idOtroEmpleador);
        this.calcularTotalConceptos(this.conceptosList);

        this.snackBar.open(this.mensajeExitoGuardado, "OK", { duration: 10000 });
      }
    });
  }

  editConcepto(row, rowIndex)
  {
    this.abrirDialogo(row, rowIndex);
  }

  deleteConcepto(row, rowIndex)
  {
    let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result)
      {
        if (this.otroEmpleador.id == 0)
        {
          this.conceptosList.splice(rowIndex, 1);

          this.cargarConceptos(row.idOtroEmpleador);
          this.calcularTotalConceptos(this.conceptosList);
          return;
        }

        let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
          width: '400px'
        });
        dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

        this.eliminando = true;
        this.otroEmpleadorService.deleteConcepto(row.id).subscribe(
          response =>
          {
            let index = this.conceptosList.findIndex(x => x.id == row.id);
            if (index != -1)
            {
              this.conceptosList.splice(index, 1);
              this.conceptosList = [...this.conceptosList];
            }

            this.cargarConceptos(row.idOtroEmpleador);
            this.calcularTotalConceptos(this.conceptosList);

            this.snackBar.open("Eliminacion de concepto correcta.", "OK", { duration: 10000 });

            this.eliminando = false;

            setTimeout(function ()
            {
              dialogProcesandoRef.close();
            });
          },
          error =>
          {
            if (error.status == 400)
            {
              this.eliminacionInvalida = true;
            }
            else
            {
              this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
            }
            this.eliminando = false;
            dialogProcesandoRef.close();
          });
      }
    });
  }

  chequeoRetro()
  {
    //Por el momento no chequea

    // this.MensajeRetro = "";
    // let fecha = this.form.get("fecha").value.toDateString();
    
    // this.personalService.ChequeoRetroactividad(this.personalId, 'OtroEmpleador', fecha, fecha, true).subscribe(
    //   data =>
    //   {
    //     let resul = data;
    //     if (resul.haceRetro)
    //     {
    //       let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
    //       this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
    //     }
    //   }
    // );
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(fecha) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(fecha) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.fecha);
      if(anterior) edita = false;  
    }
    return edita;
  }

  
}
